import { render } from "./TransManagerConstructorTab.vue?vue&type=template&id=6c3b02c6&scoped=true"
import script from "./TransManagerConstructorTab.vue?vue&type=script&lang=js"
export * from "./TransManagerConstructorTab.vue?vue&type=script&lang=js"

import "./TransManagerConstructorTab.vue?vue&type=style&index=0&id=6c3b02c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3b02c6"]])

export default __exports__